import { theme } from 'aimo-ui';
import { PermitElementRow } from 'components/services/PermitElementRow';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AccessPermitPoolingGroupCombinedInfo,
  Maybe,
} from 'types/generatedSchemaTypes';
import { PermitContentWrapper } from '../styles';
import { PoolingGroupValidityInfo } from './PoolingGroupValidityInfo';

type PoolingInfoProps = {
  poolingGroup: Maybe<AccessPermitPoolingGroupCombinedInfo> | undefined;
};

export const PoolingGroupInfo: React.FC<PoolingInfoProps> = ({
  poolingGroup,
}) => {
  const { t } = useTranslation();

  if (!poolingGroup) return null;

  return (
    <PermitContentWrapper>
      <PermitElementRow
        label={t('permit.access.availability')}
        detail={
          !poolingGroup.capacityHidden
            ? `${t('permit.access.spot', {
                count: poolingGroup.freePoolingSpots ?? 0,
              })}`
            : t('permit.access.no_data')
        }
        borderColor={'#0A0A0A0A'}
        labelColor={theme.colors.black}
        detailColor={
          !poolingGroup.capacityHidden
            ? theme.colors.black
            : theme.colors.gray300
        }
      />
      <PoolingGroupValidityInfo
        validFrom={poolingGroup.validity?.validFrom?.toString()}
        validTo={poolingGroup.validity?.validTo?.toString()}
      />
    </PermitContentWrapper>
  );
};
